module.exports = __webpack_public_path__ + "img/presse-christophe-de-barry-sm.fbb9acf4.jpg";